import { useState } from 'react';

import { withPageImpression } from '@spotify/plugin-confidence-tracking-react';

import { UnavailabilityPage } from './UnavailabilityPage';
import { UnsupportedMarketPage } from './UnsupportedMarketPage';

const UnsupportedMarketRouteComponent = () => {
  const [showForm, setShowForm] = useState(false);

  if (showForm) {
    return <UnavailabilityPage onClose={() => setShowForm(false)} />;
  }

  return <UnsupportedMarketPage onNotifyMe={() => setShowForm(true)} />;
};

export const UnsupportedMarketRoute = withPageImpression(
  UnsupportedMarketRouteComponent,
  { pageId: 'unsupported-market' },
);
